import { getFormData } from 'Shared/utils/formData'

import { TableUrlParams } from 'Core/interfaces'
import { Http } from 'Core/utils'

import { ServiceLocation } from 'Portals/Customer/entities'

import { baseUrl } from './constants'

export const getList = (params: TableUrlParams): Promise<ListData<ServiceLocation.Basic>> =>
	Http.get(`${baseUrl}`, { params })

export const retrieveServiceLocation = (): Promise<Entity[]> => Http.get(`${baseUrl}/current-user`)

export const retrieveBillingLocation = (): Promise<Entity[]> =>
	Http.get(`${baseUrl}/billing-locations`)

export const retrieveProgramManager = (): Promise<Entity[]> =>
	Http.get(`${baseUrl}/program-managers`)

export const retrieveServiceSite = (id: string): Promise<ServiceLocation.Detailed> =>
	Http.get(`${baseUrl}/${id}`)

export const retrieveServiceSiteContact = (id: string): Promise<ServiceLocation.Contact.Basic[]> =>
	Http.get(`${baseUrl}/${id}/contacts`)

export const deleteContact = (serviceLocationId: number, contactId: number): Promise<void> =>
	Http.delete(`${baseUrl}/${serviceLocationId}/contacts/${contactId}`)

export const addContact = (
	data: ServiceLocation.Contact.Generic.Request,
	id: number
): Promise<void> => Http.post(`${baseUrl}/${id}`, data)

export const editContact = (
	data: ServiceLocation.Contact.Generic.Request,
	id: number,
	contactId: number
): Promise<void> => Http.put(`${baseUrl}/${id}/contacts/${contactId}`, data)

export const retrieveServiceLocationContactById = ({
	id,
	contactId
}: {
	id: number
	contactId: number
}): Promise<ServiceLocation.Contact.Detailed> => Http.get(`${baseUrl}/${id}/contacts/${contactId}`)

export const retrieveServices = (id: string): Promise<ServiceLocation.Service.Basic[]> =>
	Http.get(`${baseUrl}/${id}/current-service-product-state`)

export const deleteService = (serviceLocationId: number, serviceId: number): Promise<void> =>
	Http.delete(`${baseUrl}/${serviceLocationId}/current-service-product-state/${serviceId}`)

export const retrieveServiceLocationServiceById = ({
	id,
	serviceId
}: {
	id: number
	serviceId: number
}): Promise<ServiceLocation.Service.Basic> =>
	Http.get(`${baseUrl}/${id}/current-service-product-state/${serviceId}`)

export const addService = (data: ServiceLocation.Service.Request, id: number): Promise<void> =>
	Http.post(`${baseUrl}/${id}/current-service-product-state`, data)

export const editService = (
	data: ServiceLocation.Service.Request,
	id: number,
	serviceId: Key
): Promise<void> => Http.put(`${baseUrl}/${id}/current-service-product-state/${serviceId}`, data)

export const checkContactEmail = (email: string): Promise<void> =>
	Http.get('/contacts/exists', { params: { email } })

export const retrieveTreatmentMethods = (): Promise<Entity[]> => Http.get(`items/treatment-methods`)

export const retrieveSupplierContacts = (
	id: Key
): Promise<ServiceLocation.SupplierContact.Basic[]> =>
	Http.get(`${baseUrl}/${id}/current-supplier-contact`)

export const deleteSupplierContact = (
	serviceLocationId: number,
	serviceId: number
): Promise<void> =>
	Http.delete(`${baseUrl}/${serviceLocationId}/current-supplier-contact/${serviceId}`)

export const addSupplierContact = (
	data: ServiceLocation.SupplierContact.Form,
	id: number
): Promise<void> => Http.post(`${baseUrl}/${id}/current-supplier-contact`, data)

export const editSupplierContact = (
	data: ServiceLocation.SupplierContact.Form,
	id: number,
	contactId: number
): Promise<void> => Http.put(`${baseUrl}/${id}/current-supplier-contact/${contactId}`, data)

export const retrieveSupplierContact = ({
	id,
	contactId
}: {
	id: number
	contactId: Key
}): Promise<ServiceLocation.SupplierContact.Detailed> =>
	Http.get(`${baseUrl}/${id}/current-supplier-contact/${contactId}`)

export const retrieveHistoricalInvoices = (
	id: Key
): Promise<ServiceLocation.HistoricalInvoice.Basic[]> =>
	Http.get(`${baseUrl}/${id}/historical-invoices`)

export const downloadHistoricalInvoice = (id: Key, historicalInvoiceId: Key): Promise<Blob> =>
	Http.get(`${baseUrl}/${id}/historical-invoices/${historicalInvoiceId}/download`, {
		responseType: 'blob'
	})

export const deleteHistoricalInvoice = (id: Key, historicalInvoiceId: Key): Promise<void> =>
	Http.delete(`${baseUrl}/${id}/historical-invoices/${historicalInvoiceId}`)

export const uploadHistoricalInvoice = (
	id: Key,
	data: ServiceLocation.HistoricalInvoice.Request
): Promise<ServiceLocation.HistoricalInvoice.Basic> => {
	const formData = getFormData<ServiceLocation.HistoricalInvoice.Request>(data)

	return Http.post(`${baseUrl}/${id}/historical-invoices`, formData, {
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	})
}
